import axios from "axios";

export const fetchProductsPerPage = async (page, genreID) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/products?per_page=25&tag=${genreID}&page=${page}`
  );
  return data;
};

export const fetchProducts = async () => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/products`
  );
  return data;
};


export const fetchTopSales = async () => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/products/?orderby=popularity&order=desc`
  );
  return data;
};

export const fetchUserFavorites = async (token) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/products/favorites`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const fetchUserLibrary = async (user_id) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/products/library?user_id=${user_id}`
  );
  return data;
};

export const fetchProduct = async (slug, user_id = null, token = null) => {
  const url = user_id
    ? `${process.env.REACT_APP_API_BASE_URL}/products/${slug}?slug=${slug}&user_id=${user_id}`
    : `${process.env.REACT_APP_API_BASE_URL}/products/${slug}?slug=${slug}`;

  const { data } = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

export const addFavoriteApi = async (productId, token) => {
  return await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/favorites/${productId}`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const removeFavoriteApi = async (productId, token) => {
  return await axios.delete(
    `${process.env.REACT_APP_API_BASE_URL}/favorites/${productId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};
